import React, {useState, useImperativeHandle, forwardRef} from 'react';
import { Button, Modal } from 'antd';
import { examination } from '@/api/examinationApi';
import { history, useLocation } from "umi";


/** 提交弹窗 */
const SubmitModal = (props, ref) => {
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [modalText, setModalText] = React.useState('是否提交试卷');
  const [visible, setVisible] = useState(false);
  const [submitData, setSubmitData] = useState<API.examinationSubmitParams>();
  const { query } = useLocation() as unknown as Location & { query: Record<string, string> };

  useImperativeHandle(ref, () => ({
    open: (val: API.examinationSubmitParams) => {
      setVisible(true);
      setSubmitData(val);
    },
    timeUseUp: (val:API.examinationSubmitParams) => {
      handleSubmit(val);
    }
  }));
  
  /** 处理提交 */
  const handleSubmit = (val?:API.examinationSubmitParams) => {
    setModalText('试卷正在提交，请耐心等待');
    window.Pandora.send('zijin_testee_confirm_submit', {
      onlyid: query.exam_id,
      data: JSON.stringify(val || submitData!)
    });
    setConfirmLoading(true);
    examination.submit(val || submitData!)
          .then(res => {
            setModalText('试卷已提交成功');
            setConfirmLoading(false);
            history.replace({
              pathname: '/result_exam',
              query: {
                status: String(res.code),
                exam_id: query.exam_id,
              },
            });
          })
          .catch(e => {
            console.log(e);
            setConfirmLoading(false);
            setModalText('试卷提交失败');
          });
  };

  /** 取消 */
  const handleCancel = () => {
    window.Pandora.send('zijin_testee_cancel_submit', {
      onlyid: query.exam_id,
    });
    setVisible(false);
  };

  return (
    <Modal
        title="笔试提交"
        visible={visible}
        centered
        onOk={() => handleSubmit()}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            取消
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={() => handleSubmit()}
          >
            提交
          </Button>,
        ]}
      >
        <p>{modalText}</p>
      </Modal>
  );
};

export type SubmitModalRef = {
  /** 打开弹窗 */
  open: (params: API.examinationSubmitParams) => void;
  timeUseUp: (params: API.examinationSubmitParams) => void
}

export default forwardRef(SubmitModal);
